import Link from 'components/link/Link';

import { IOfficeBlockInfo } from 'source/NFR.types';

const OfficeBlockInfo: React.FC<IOfficeBlockInfo> = ({ link, moreText, text, title }) => (
  <div className="office-block-info">
    {title && <h3>{title}</h3>}
    {text && <p>{text}</p>}
    {moreText && <p>{moreText}</p>}
    {link && <Link theme="underline" {...link} />}
  </div>
);

OfficeBlockInfo.displayName = 'OfficeBlockInfo';

export default OfficeBlockInfo;
